import { batchMovePersonToRelationshipRecord, getRelationshipLabel, getNestedOrFloatingElementById } from '@fs/zion-sls'
import { replaceRelationshipPerson as sharedReplaceRelationshipPerson } from './elementUtils'

export const ensureRelPeopleAreInSameRecord = ({
  images,
  selectedPerson,
  movingPersonToOtherRecord,
  otherPerson,
  keepThisRelationshipId,
}) => {
  let dispatches = []

  if (otherPerson.recordId !== selectedPerson.recordId) {
    if (movingPersonToOtherRecord) {
      dispatches = batchMovePersonToRelationshipRecord({
        mainPerson: selectedPerson,
        otherPerson,
        images,
        movingMainPersonToOtherRecord: movingPersonToOtherRecord,
        keepThisRelationshipId,
      })
    } else {
      dispatches = dispatches.concat(
        batchMovePersonToRelationshipRecord({
          mainPerson: selectedPerson,
          otherPerson,
          images,
          movingMainPersonToOtherRecord: movingPersonToOtherRecord,
          keepThisRelationshipId,
        })
      )
    }
  }
  return dispatches
}

export const replaceRelationshipPerson = sharedReplaceRelationshipPerson

export const editEventRelationship = ({
  slsImages,
  parentRelationship,
  selectedPerson,
  otherPerson,
  movingPersonToOtherRecord,
  relationshipPerson,
  el,
}) => {
  if (otherPerson) {
    const relationshipDispatches = ensureRelPeopleAreInSameRecord({
      images: slsImages,
      selectedPerson,
      otherPerson,
      movingPersonToOtherRecord,
      keepThisRelationshipId: el.id,
    })
    const relationshipOrder =
      parentRelationship.superElements.find((supEl) => supEl.id === selectedPerson.id)?.order === 'FIRST'
        ? 'SECOND'
        : 'FIRST'

    if (el.superElements.length > 1) {
      return [
        ...relationshipDispatches,
        ...replaceRelationshipPerson({
          relationshipField: el,
          selectedPersonId: selectedPerson.id,
          order: relationshipOrder,
          otherPerson,
          value: relationshipPerson,
        }),
      ]
    }
    return [
      ...relationshipDispatches,
      {
        type: 'ADD_SUB',
        value: {
          superId: otherPerson.id,
          subId: el.id,
          superPartitionKey: otherPerson.partitionKey,
          subPartitionKey: el.partitionKey,
          elementType: 'PERSON',
          extraArgs: { order: relationshipOrder },
        },
      },
    ]
  }

  if (parentRelationship?.superElements?.length > 1) {
    const superElToRemoveId = parentRelationship.superElements.find((supEl) => supEl.id !== selectedPerson.id)?.id
    if (superElToRemoveId) {
      const superElToRemove = getNestedOrFloatingElementById(slsImages, superElToRemoveId)
      if (superElToRemove) {
        return [
          {
            type: 'REM_SUB',
            value: {
              superPartitionKey: superElToRemove.partitionKey,
              subPartitionKey: parentRelationship.partitionKey,
              superId: superElToRemove.id,
              subId: parentRelationship.id,
              elementType: 'PERSON',
            },
          },
        ]
      }
    }
  }
  return []
}

export const getRelationshipInputLabels = ({ t, types, mainPerson, otherPerson, parentRelationship, eventType }) => {
  let mainPersonLabel = t('type-unknown.label', '<Unknown Type>')
  let secondaryPersonLabel = t('type-unknown.label', '<Unknown Type>')

  if (parentRelationship) {
    mainPersonLabel = getRelationshipLabel({
      otherPerson: mainPerson,
      order: parentRelationship?.order,
      typeData: parentRelationship?.typeData,
    })
    secondaryPersonLabel = getRelationshipLabel({
      otherPerson,
      order: parentRelationship?.order === 'FIRST' ? 'SECOND' : 'FIRST',
      typeData: parentRelationship?.typeData,
    })
  } else {
    const relationshipType = types.relationships.find((relationship) => relationship.relType === eventType.relType)
    mainPersonLabel = relationshipType?.firstDisplayLabel
    secondaryPersonLabel = relationshipType?.secondDisplayLabel
  }

  return { mainPersonLabel, secondaryPersonLabel }
}
